export function resizeImageTo1920(file: File): Promise<Blob> {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('image/')) {
      // Not an image – skip processing
      return resolve(file);
    }

    const reader = new FileReader();
    const img = new Image();

    reader.onload = (event: any) => {
      img.src = event.target.result;
    };

    reader.onerror = () => reject(new Error('FileReader failed'));

    img.onload = () => {
      const MAX_WIDTH = 1920;
      let width = img.width;
      let height = img.height;

      if (width > MAX_WIDTH) {
        const scaleFactor = MAX_WIDTH / width;
        width = MAX_WIDTH;
        height = height * scaleFactor;
      } else {
        // No resizing needed
        return resolve(file);
      }

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      if (!ctx) return reject(new Error('Canvas context not available'));

      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          if (blob) resolve(blob);
          else reject(new Error('Canvas conversion failed'));
        },
        file.type,
        0.92
      );
    };

    img.onerror = () => reject(new Error('Invalid image'));

    reader.readAsDataURL(file);
  });
}
